import { useContext } from 'react';
import './App.scss';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginContext } from './contexts/LoginContext';
import { AnimatePresence } from 'framer-motion';
import { CartContext } from './contexts/CartContext';
//use lazy 
import { lazy, Suspense } from 'react';
import Login from './Page/Auth/Login';
import TypewriterEffect from './TypewriterEffect';


const fakeLazy = (props: any) => {
  return new Promise((resolve) =>{
    setTimeout(resolve, 1000)}).then(() => props);
  }

const Home  = lazy(() =>  fakeLazy(import('./Page/Home/Home')));
const LineButton = lazy(() =>  import('./component/Others/LineButton'));
const UserBar = lazy(() => import('./component/Navigation/UserBar'));
const ErrorPage = lazy(() => import('./Page/Error/ErrorPage'));
const Products = lazy(() => import('./Page/Products/Products'));
const CompleteTrading = lazy(() => import('./Page/Trading/CompleteTrading'));
const Product = lazy(() => import('./Page/Product/Product'));
const Cart = lazy(() => import('./Page/Cart/Cart'));

const OrderProductsList = lazy(() => import('./SubPage/OrderProductsList'));
const Orders = lazy(() => import('./SubPage/Orders/Orders'));
const ProductImgUpdated = lazy(() => import('./AdminPage/ProductImgUpdated'));
const EditProduct = lazy(() => import('./AdminPage/EditProduct'));
const Register = lazy(() => import('./Page/Auth/Register'));
const OrderInfo = lazy(() => import('./Page/Order/OrderInfo'));


const LoadingAnimation = () => (
  <div className="loading-animation">
    <div className="loading-text">Chiioa</div>
  </div>
);


function App() {
  const { user } = useContext(LoginContext);
  const { cart } = useContext(CartContext);
  return (
    <div className="App">
      <BrowserRouter >
      <AnimatePresence >
          <Suspense fallback={<TypewriterEffect/>}>
            <Routes >
              <Route path="*" element={<ErrorPage />} />
              <Route path='/' element={<Home />} />
              <Route path='/:type' element={<Home />} />
              <Route path='/products/' element={<Products />} />
              <Route path='/trading' element={<CompleteTrading />} />
              <Route path='/product/:id' element={<Product />} />
              <Route path='/cart' element={<Cart />} />
              {/* <Route path='/trend' element={<Trend/>} /> */}
              <Route path='/order/productslist' element={<OrderProductsList />} />
              <Route path='/orders' element={<Orders />} />
              <Route path='/admin/backend/img/update' element={<ProductImgUpdated />} />
              <Route path='/admin/backend/editproduct' element={<EditProduct />} />

              {user ?
                <>
                  <Route path='/login' element={<Navigate to="/" />} />
        
                  <Route path='/register' element={<Navigate to="/" />} />
                </>
                :
                <>
                  <Route path='/login' element={<Login />} />
                {/*登入line/fb如沒有帳號跳轉去register*/}
                  <Route path='/register' element={<Register />} />
                </>
              }
              {cart ?
                <Route path='/orderinfo' element={<OrderInfo />} />
                :
                <Route path='/orderinfo' element={<Navigate to="/" />} />
              }
              {/* <Route path='/orderinfo' element={<OrderInfo />} /> */}
              {/* <Route path='/auth/privacy' element={<Privacy />} /> */}
            </Routes>

          </Suspense>
        </AnimatePresence>
        <LineButton />
        {user && <UserBar />}
      </BrowserRouter>
    </div>
  );
}

export default App;
function wait(arg0: number) {
  throw new Error('Function not implemented.');
}

